import { Chip } from "ui/chip";

import { ChannelIcon } from "components/partials/channel-icon/channel-icon";
import { getFieldUiType, type JsonFormSchema } from "containers/admin/clients/client/components/form-builder/form-schema";

import { EMPTY_DISPLAY_VALUE } from "constants/ui";

type FormBuilderDataTableCellProps = {
  columnId: string;
  field: JsonFormSchema;
  value: string;
  rawValue: unknown;
};

const isEmptyCellValue = (value: string): boolean =>
  value.trim().length === 0 || value === EMPTY_DISPLAY_VALUE;

const FormBuilderDataTableCell = ({ columnId, field, value, rawValue }: FormBuilderDataTableCellProps) => {
  if (isEmptyCellValue(value)) {
    return null;
  }

  const uiType = getFieldUiType(field);

  if (columnId === "channel") {
    return (
      <span className="flex items-center gap-3">
        <ChannelIcon channel={typeof rawValue === "string" ? rawValue : undefined} />
        <span className="whitespace-nowrap text-sm font-normal leading-5 text-gray-600">{value}</span>
      </span>
    );
  }

  if (columnId === "audienceType") {
    return <Chip size="small" color="default" variant="outlined" label={value} />;
  }

  if (uiType === "select" || uiType === "select-search" || uiType === "radio-group") {
    return (
      <span className="block truncate text-base font-normal leading-6 text-gray-600">{value}</span>
    );
  }

  if (uiType === "textarea" || value.includes("\n")) {
    return (
      <span className="whitespace-pre-wrap break-words text-base font-normal leading-6 text-gray-600">
        {value}
      </span>
    );
  }

  return (
    <span className="block truncate text-base font-normal leading-6 text-gray-600">{value}</span>
  );
};

export default FormBuilderDataTableCell;
